'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgDelete(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("g", { transform: "translate(2 2)" },
                React__default.default.createElement("path", { d: "M0 0h12v12H0z" }),
                React__default.default.createElement("path", { d: "M8.571 4v6.667H3.43V4H8.57M7.182 0H4.818a1 1 0 00-.72.306l-.348.36H2.167a.667.667 0 100 1.334h7.666a.667.667 0 100-1.333H8.25L7.902.306A1 1 0 007.182 0zm1.675 2.667H3.143a1 1 0 00-1 1v7C2.143 11.4 2.72 12 3.429 12H8.57c.708 0 1.286-.6 1.286-1.333v-7a1 1 0 00-1-1z", fill: "currentColor" }),
                React__default.default.createElement("rect", { fill: "currentColor", x: 4.5, y: 5.5, width: 1, height: 4, rx: 0.5 }),
                React__default.default.createElement("rect", { fill: "currentColor", x: 6.5, y: 5.5, width: 1, height: 4, rx: 0.5 })))));
}

module.exports = SvgDelete;
//# sourceMappingURL=Delete.js.map
